import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toast } from 'react-toastify';

import { Grid, Dialog, Button, IconButton, TextField, DialogContent, DialogTitle, useTheme, useMediaQuery } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import CloseIcon from '@mui/icons-material/Close';

import './modalDatosIniciales.css';
import { iniUpdateBudget, budgetsUpdateCondicionesNotSave, iniUpdateBudgetModeTemplate } from '../../../redux/actions/pptos';
import { PptosCondicionesFormasDePago } from './PptosCondicionesFormasDePago';

export const PptosCondiciones = ({ open, setOpen }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // móvil: sm o menor

    const dispatch = useDispatch();
    const { access } = useSelector(state => state.auth)
    const { listaFormasPagosVentas } = useSelector(state => state.general);
    const detailBudget = useSelector(state => state.ppto.detail)


    const {
        id_forma_pago,
        forma_pago,
        fecha_vencimiento,
        observaciones,
        no_incluye,
        terminos_condiciones,
        template_mode,
        // fecha_creacion,
        otras_formas_pago,
        fecha_estimada_forma_pago,
        estado_negocio,
        estado_cierre
    } = detailBudget

    const yesModify = ((estado_negocio === 'por aprobar' || access.a24) && (estado_cierre !== 'cerrado' && estado_cierre !== 'pausado'))
    // const [yesModify, setYesModify] = useState(yes)
    // const yesModify = yes

    const [form, setForm] = useState({
        id_forma_pago: id_forma_pago,
        forma_pago: forma_pago,
        fecha_vencimiento: fecha_vencimiento,
        observaciones: observaciones,
        no_incluye: no_incluye,
        terminos_condiciones: terminos_condiciones,
        otras_formas_pago: otras_formas_pago || [],
        fecha_estimada_forma_pago: fecha_estimada_forma_pago
    });

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value,
        });
    }

    const handleChangeDateVcto = (newValue) => {
        setForm({
            ...form,
            fecha_vencimiento: newValue
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const newDetail = {
            ...detailBudget,
            id_forma_pago: form.id_forma_pago,
            forma_pago: form.forma_pago,
            fecha_vencimiento: form.fecha_vencimiento,
            observaciones: form.observaciones,
            no_incluye: form.no_incluye,
            terminos_condiciones: form.terminos_condiciones,
            otras_formas_pago: form.otras_formas_pago,
            fecha_estimada_forma_pago: form.fecha_estimada_forma_pago
        };

        if (newDetail.id > 0 && !template_mode) {

            const originalDetailRaw = localStorage.getItem('budget-detail-init-data')
            const originalDetailObj = originalDetailRaw ? JSON.parse(originalDetailRaw) : null
            const isDirty = JSON.stringify(newDetail) !== JSON.stringify(originalDetailObj)
            if (!isDirty) {
                toast.info('No se han detectado cambios para guardar')
                return false
            }

            dispatch(iniUpdateBudget(newDetail))
            
        } else {
            if (template_mode) {
                dispatch(iniUpdateBudgetModeTemplate(newDetail))
            } else {
                dispatch(budgetsUpdateCondicionesNotSave(newDetail))
                toast.success('presupuesto actualizado');
            }
        }
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
            fullScreen={isMobile}
            PaperProps={{
                className: isMobile ? '' : 'min-w-[80%]'
            }}
        >
            <DialogTitle>Condiciones generales</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <form onSubmit={handleSubmit}>

                    {yesModify ?
                        <div className='text-start'>
                            <Button
                                style={{ width: '150px' }}
                                id="id-button-save-ppto"
                                className='p-btn-primary'
                                variant="contained"
                                size='medium'
                                type='submit'
                            >
                                Guardar cambios
                            </Button>
                        </div> : ''
                    }


                    <Grid container className={yesModify ? 'mt-5' : ''}>
                        <Grid item xs={12}>
                            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                                <PptosCondicionesFormasDePago
                                    setForm={setForm}
                                    form={form}
                                    listaFormasPagos={listaFormasPagosVentas}
                                    handleSubmit={handleSubmit}
                                    yesModify={yesModify}
                                />

                                <Grid item xs={6} className='p-text-date-range d-flex align-items-end'>
                                    <span>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                label="Fecha vcto. presupuesto"
                                                inputFormat="DD/MM/YYYY"
                                                name="fecha_vencimiento"
                                                value={form.fecha_vencimiento}
                                                onChange={handleChangeDateVcto}
                                                renderInput={(params) => <TextField {...params} />}
                                                disabled={!yesModify}
                                            />
                                        </LocalizationProvider>
                                    </span>
                                    <label className='ms-2'>(5 días a partir de la creación)</label>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        id="outlined-multiline-static"
                                        name="observaciones"
                                        label="Observaciones"
                                        multiline
                                        rows={4}
                                        value={form.observaciones || ''}
                                        onChange={handleChange}
                                        disabled={!yesModify}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        id="outlined-multiline-static"
                                        name="no_incluye"
                                        label="No Incluye"
                                        multiline
                                        rows={4}
                                        value={form.no_incluye || ''}
                                        onChange={handleChange}
                                        disabled={!yesModify}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        id="outlined-multiline-static"
                                        name="terminos_condiciones"
                                        label="Términos y condiciones"
                                        multiline
                                        rows={4}
                                        value={form.terminos_condiciones || ''}
                                        onChange={handleChange}
                                        disabled={!yesModify}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* <div style={{ marginTop: '27px', textAlign: 'right' }}>
                        <Button
                            id="id-button-save-ppto"
                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            type='submit'
                        >
                            Guardar
                        </Button>
                    </div> */}

                </form>
            </DialogContent>
        </Dialog >
    )
}
